module.exports = __webpack_public_path__ + "img/5.891fa145.png";